// extracted by mini-css-extract-plugin
module.exports = {"background":"Hero-module--background--3cAhH","tablet":"Hero-module--tablet--kO_IV"};